import { MediaManagerSDKAnyItem } from '../../../media-manager-sdk';

export enum ItemSelectOrigin {
  Click = 'click',
  CtrlA = 'ctrl_a',
  Lasso = 'lasso',
  DoubleClick = 'double_click',
}

export type SelectItemAdditionalParams = {
  clickOrigin: ItemSelectOrigin;
  tabName: string;
};

export interface IUseTrackItemSelectAnalyticsInner {
  trackItemsSelected: (items: MediaManagerSDKAnyItem[], params: Partial<SelectItemAdditionalParams>) => void;
}
